import { Colors } from '@psl/components/styles/Colors';
import { memo } from 'react';
import {
  ActivityIndicator,
  Platform,
  StyleProp,
  ViewStyle,
} from 'react-native';
import { Center } from '../components/Center';

export const PageLoading = memo(
  ({ style }: { style?: StyleProp<ViewStyle> }) => {
    return (
      <Center
        style={style}
        css={`
          flex: 1;
        `}
      >
        <ActivityIndicator
          size="large"
          color={Platform.OS === 'web' ? Colors.Gray3 : undefined}
        />
      </Center>
    );
  },
);
